import { render, staticRenderFns } from "./TransactionsView.vue?vue&type=template&id=b7bad8e2&"
var script = {}
import style0 from "./TransactionsView.vue?vue&type=style&index=0&id=b7bad8e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports